<div class="relative aspect-[1920/1080]">
  <div class="absolute inset-0 size-full">
    <app-image-thumbnail
      [rounded]="false"
      size="full">
      <img
        [alt]="imageAlt()"
        [fill]="true"
        [ngSrc]="imageSrc()"
        class="object-contain" />
    </app-image-thumbnail>
  </div>
</div>
